export default __webpack_public_path__ + "static/media/Head_4_Ear_3_C5.817f2bbf.svg";